module.exports = new __parcel__URL__("lizard.de3c3103.svg").toString();